import type { IntelMemory } from "./executive";

/** Caminho da memória de cálculo — mesmo formato do `MemoryLink`. */
export function memoryPath(m: IntelMemory): string {
  const params = new URLSearchParams();
  if (m.periodFrom && m.periodTo) {
    params.set("periodFrom", m.periodFrom);
    params.set("periodTo", m.periodTo);
  }
  const qs = params.toString();
  return `/${m.area ?? "financeiro"}/memoria/${m.cardKey}${qs ? `?${qs}` : ""}`;
}
